export default {
      id: "camera-usage",
      viewBox: "0 0 256 256",
      url: "/dist/svg/" + "sprite.svg#camera-usage",
      toString: function () {
        return this.url;
      }
    }